import React from 'react';

import CarAttributesMainGroup from './CarAttributesMainGroup';
import CarAttributesAccordion from './CarAttributesAccordion';

import Classes from './CarAttributes.scss';

import { TListingCarAttributes, TListingCarDetailGroupedWithIcon, TListingClient } from 'types/TListing';

type TCarAttributesProps = {
  carAttributes?: TListingCarAttributes;
  carDetails: TListingClient['carDetails'];
};

const ONE_COLUMN_ITEMS = 3;
const MAIN_GROUP_KEY = 'Main';

const CarAttributes = ({ carAttributes, carDetails }: TCarAttributesProps) => {
  const carAttributesGroupedWithIcons: TListingCarDetailGroupedWithIcon[] = carAttributes?.groupedWithIcons || [];
  const mainGroup = carAttributesGroupedWithIcons.find((group) => group.key === MAIN_GROUP_KEY);
  const mainGroupAttributes = mainGroup ? mainGroup.attributes : [];
  const listOverviewClassNames = [Classes.list]
    .concat([mainGroupAttributes.length <= ONE_COLUMN_ITEMS ? Classes.oneColumn : ''])
    .join(' ');

  return (
    <section className={`block-wrapper-s ${Classes.root}`}>
      <div className={listOverviewClassNames}>
        {mainGroupAttributes.map((item) => (
          <CarAttributesMainGroup item={item} key={item.key} carDetails={carDetails} />
        ))}
      </div>
      {carAttributes && <CarAttributesAccordion carAttributes={carAttributes} />}
    </section>
  );
};

export default CarAttributes;
